import * as React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {default as PromoEdit} from '../../components/Promociones/edit'
import { getPromocionEdit, sagaSavePromociones } from '../../reducers/promocionesReducer/actions'
import { promoEditSelector } from '../../selectors/promocionesSelector'

class PromocionesEditContainer extends React.Component {

    constructor(props) {
        super(props)
        this.state= {
            promo: {
                nombre:"",
                limiteInferior:"",
                limiteSuperior:"",
                porcentajeDescuento:"",
            },
            cargandoPromo: true,
            error:undefined,
        }
        // busco los datos iniciales
        let id =  props.match.params.idPromo
        if (id === "0") id = 0;
        props.getPromocionEdit(id)
    }

    valido(){
        /*
        let u = this.state.usuario
        let error = { valido: true }
        if (u.email === "" || u.email === null)
            { error.email = "debe definir un email de usuario"; error.valido=false; } 
        else if(!this.validateEmail(u.email))
            { error.email = "debe definir un email valido"; error.valido=false; } 
        
        if (u.nombre === "" || u.nombre === null){ error.nombre = "debe definir un nombre"; error.valido=false; }
        if (u.apellido === "" || u.apellido === null){ error.apellido = "debe definir un apellido"; error.valido=false; }
        if(u.tipoRol === 1)
        {
            if (u.nombreUsuario === "" || u.nombreUsuario === null){ error.nombreUsuario = "debe definir un nombre de usuario"; error.valido=false; } 
            if (u.rol === "" || u.rol === null){ error.rol = "debe definir un rol de usuario"; error.valido=false; } 
        }
        if (error.valido)
            return true
        else
        {
            this.setState({error})
            return false
        }
        */
       return true;
    }

    componentWillReceiveProps(nextProps){
        if (nextProps.promocion && nextProps.promocion.id!==undefined){
        this.setState({promo: nextProps.promocion, cargandoPromo:false}, ()=>{this.render()})
        }
        this.render()
    }

    render() {
        if (!this.state.promo) return <div></div>
        return <PromoEdit 
        promocion={this.state.promo}
        error={this.state.error}
        handleOnChange={(x,y)=>{
            this.setState(
            {promo:
                {...this.state.promo,
                    ...pathValue(x.target.name, x.target.value)  }
                }
            )}
            }
        handleOnCancel={()=>{this.props.history.goBack()}}
        handleOnSave={()=>{
            if (this.valido()){
                this.setState({cargandoUsuario:false})
                this.props.sagaSavePromociones({...this.state.promo,
                    limiteInferior: toNumber2(this.state.promo.limiteInferior),
                    limiteSuperior: toNumber2(this.state.promo.limiteSuperior),
                    porcentajeDescuento: toNumber2(this.state.promo.porcentajeDescuento)})
                }
        }}
    />
    }
}

function pathValue(path, value){
    return {[path]:value}
}

function toNumber2(s){//limpia los strings de los currency inputs
    if (typeof s === 'string' || s instanceof String){
        let n = s.replace("$","").replace("%","").replace(/\./g,"").replace(",",".")
        let numero = parseFloat(n)
        return numero
    }
    else{
        let num = parseFloat(s)
        return num
    }
 }

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
        getPromocionEdit,
        sagaSavePromociones
	}, dispatch)
}

function mapStateToProps(state) {
	return {
        promocion: promoEditSelector(state)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PromocionesEditContainer)